import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import NegociatedItem from "app/pages/FicheProduit/NegociatedList/NegociatedItem";
import { ButtonLink } from "app/components/ui/ButtonLink/ButtonLink";
import TicketFilledIcon from "app/icons/finance/TicketFilledIcon";
import { ICON_SIZES } from "app/constants";
import { EMIRATES_PASS_URL } from "src/@brand/appConstants";
import "./EmiratesPassNegociatedItem.scss";

const EmiratesPassNegociatedItem = ({ sizeIcon, labelVariantMD }) => {
	const intl = useIntl();

	return (
		<NegociatedItem
			customPicto={<TicketFilledIcon size={sizeIcon} />}
			label={intl.formatMessage({ id: "product.badge.emirates.pass" })}
			labelPrefix={
				<ButtonLink
					variant="borderless"
					to={EMIRATES_PASS_URL}
					target="_blank"
					rel="noopener noreferrer"
					className="emirates-pass-negociated-item__link"
				>
					<FormattedMessage id="product.negociated.emirates.pass.link" />
				</ButtonLink>
			}
			sizeIcon={sizeIcon}
			labelVariantMD={labelVariantMD}
		/>
	);
};

EmiratesPassNegociatedItem.propTypes = {
	sizeIcon: PropTypes.oneOf(Object.values(ICON_SIZES)).isRequired,
	labelVariantMD: PropTypes.string,
};

export default EmiratesPassNegociatedItem;
